import Immutable from 'immutable';

const initialState = Immutable.Map();

function cancellation_policy_options_load_start(state, _payload) {
  state.setIn(['options', 'loading'], true);
  state.setIn(['options', 'error'], false);
  return state;
}

function cancellation_policy_options_load_cached(state, _payload) {
  state.setIn(['options', 'loading'], false);
  return state;
}

function cancellation_policy_options_loaded(state, payload) {
  state.setIn(['options', 'loading'], false);
  state.setIn(['options', 'error'], false);
  state.setIn(['options', 'record'], payload);
  return state;
}

function cancellation_policy_options_load_failed(state, _payload) {
  state.setIn(['options', 'loading'], false);
  state.setIn(['options', 'error'], true);
  return state;
}

export default function reduce(state = initialState, { type, payload }) {
  return state.withMutations((mutableState) => {
    if (!mutableState.options) {
      mutableState.options = {};
    }

    return (
      {
        CANCELLATION_POLICY_OPTIONS_LOAD_START:
          cancellation_policy_options_load_start,
        CANCELLATION_POLICY_OPTIONS_LOAD_CACHED:
          cancellation_policy_options_load_cached,
        CANCELLATION_POLICY_OPTIONS_LOADED: cancellation_policy_options_loaded,
        CANCELLATION_POLICY_OPTIONS_LOAD_FAILED:
          cancellation_policy_options_load_failed,
      }[type] || (() => mutableState)
    )(mutableState, payload);
  });
}
